<template>
    <div id="back-forward-buttons" class="lb-btn-container">
        <div class="grey-outline-pill-button" v-on:click="goBackward">Назад</div>
        <div class="red-pill-button-of-hate go-next extra-left-margin" v-on:click="goForward">Далее</div>
    </div>
</template>

<script>
    import {bus} from "../../../vue_bus";

    export default {
        name: "RightLowerBarNavButtons",
        props: {
            version: {
                type: String
            }
        },
        computed: {
            activeStep() {
                return this.$store.state.route.name
            },
            stepsOrder(){
                return this.$store.state.UI.stepsChain[this.version].stepsOrder;
            },
            adjacentSteps() {
                return this.stepsOrder[this.activeStep]
            }
        },
        methods: {
            async goForward() {
                // if (this.activeStep === 'designGroupsSelected') {
                //     const idDesignGroup = this.$store.state.route.params.idDesignGroup;
                //     const facadeElement = this.$store.state.route.params.facadeElement;
                //     const uuidProduct = this.$store.getters["active/DESIGN_GROUPS"][idDesignGroup][facadeElement];
                //     if(uuidProduct){
                //         await this.$router.push({name: this.adjacentSteps.nextSelected, params: {productUUID: uuidProduct}});
                //         return;
                //     }
                // }
                if(this.adjacentSteps.next === "SetScale"){
                    if(this.$store.getters["active/CHECK_SCAlE_PHOTO"]){
                        await this.$router.push({name: this.stepsOrder[this.adjacentSteps.next].alternativeNext, query: this.$store.state.route.query }).catch(err=>{});
                        return;
                    }
                }
                await this.$router.push({name: this.adjacentSteps.next, query: this.$store.state.route.query}).catch(err=>{});
            },
            goBackward() {
                this.$router.push({name: this.adjacentSteps.prev, query: this.$store.state.route.query}).catch(err=>{})
            }
        }
    }
</script>

<style scoped>

</style>
